class Validations {
    static isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);
    static isNumberOrVoid = (n) => !n || n==='' || ( !isNaN(parseFloat(n)) && isFinite(n));
}
export {Validations}

